export const QUOTE_ID = 'quoteId';

export const quotePageTableColumnOptions = {
    data: [
        { field: 'quoteNumber', label: 'Quote Number' },
        { field: 'status', label: 'Status' },
        { field: 'quoteVersion', label: 'Version' },
        { field: 'quoteCreationDate', label: 'Creation Date' },
        { field: 'quoteCreatedBy', label: 'Created By' },
        { field: 'quoteProductCount', label: 'Products Included' },
        { field: 'quoteGrandTotal', label: 'Grand Total' },
        { field: 'dueDate', label: 'Quote Due Date' },
        { field: 'quoteOwner', label: 'Quote Owner' },
        { field: 'bomName', label: 'Bill Of Materials' },
        { field: 'primary_contact', label: 'Primary Customer' },
        { field: 'projectName', label: 'Project' },
        { field: 'projectStage', label: 'Project Stage' },
        { field: 'branchLocation', label: 'Branch Location' },
        { field: 'erpId', label: 'Project ERP ID' },
        { field: 'projectId', label: 'Project ID' },
        { field: 'scope', label: 'Scope' },
        { field: QUOTE_ID, label: 'Quote ID' }
    ]
};
